export const variablesToURLParams = (variables: Record<string, unknown>): string => {
  const encodeValue = (value: any) => {
    if (Array.isArray(value)) {
      return '[' + value.map(encodeURIComponent).join(',') + ']';
    } else if (typeof value === 'object' && value !== null) {
      return encodeURIComponent(JSON.stringify(value));
    } else {
      return encodeURIComponent(value.toString());
    }
  };

  const convertObjectToParams = (obj: any, parentKey = ''): string => {
    return (
      obj &&
      Object.entries(obj)
        .flatMap(([key, value]) => {
          const fullKey = parentKey ? `${parentKey}.${key}` : key;
          if ((!value && value !== false && value !== 0) || (Array.isArray(value) && value.length === 0)) {
            return undefined; // filter out undefined or empty values, but keep false and 0
          } else if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
            // recursively handle nested objects
            return convertObjectToParams(value, fullKey);
          } else {
            // return encoded key-value pair, using special handling for arrays
            return `${encodeURIComponent(fullKey)}=${encodeValue(value)}`;
          }
        })
        .filter(part => part !== undefined) // filter out undefined parts to avoid joining with '&'
        .join('&')
    );
  };

  return convertObjectToParams(variables);
};
